// extracted by mini-css-extract-plugin
export default {"chatHistory":"ChatHistory_chatHistory__LxeXN","header":"ChatHistory_header__rnWTs","chatList":"ChatHistory_chatList__c2+zQ"};